// ページャー初期値
export const initial = 1;
